if (!customElements.get('seo-text-toggle')) {
  class SeoTextToggle extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.seo-text-plp__content');
      this.button = this.querySelector('.seo-text-plp__toggle');

      if (!this.content || !this.button) return;

      this.button.addEventListener('click', this.onToggle.bind(this));
    }

    onToggle() {
      const expanded = !this.classList.contains('is-expanded');
      this.classList.toggle('is-expanded', expanded);
      this.button.setAttribute('aria-expanded', String(expanded));
      this.querySelector('.seo-text-plp__toggle-label-more').hidden = expanded;
      this.querySelector('.seo-text-plp__toggle-label-less').hidden = !expanded;

      if (expanded) {
        this.content.style.maxHeight = this.content.scrollHeight + 'px';
      } else {
        this.content.style.maxHeight = '';
        this.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  }

  customElements.define('seo-text-toggle', SeoTextToggle);
}
